import { BlocksIconShippingFast } from 'blocks-nextjs/blocks-web-components/components/icon/icons/shipping-fast';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconShippingFast = createComponent({
  react: React,
  tagName: 'cat-icon-shipping-fast',
  elementClass: BlocksIconShippingFast
});
